import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, ButtonGroup, Dropdown, DropdownButton, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Container from '../components/Container';
import ErrorComponent from '../components/ErrorComponent';
import MaskedInput from '../components/MaskedInput';
import PageComponent from '../components/PageComponent';
import Connection from '../config/Connection';
import Labels from '../Labels';
import '../styles/generics.css';
import GenericHelper from '../Tools/GenericHelper';
import Parsers from '../Tools/Parsers';
import ProgramGoalsPage from './ProgramGoalsPage';
import './ProgramNewPage.css';


const defaultInvoice = {
  accountAgency: "",
  accountBank: "",
  accountNumber: "",
  accountType: "",
  criticalValue: null,
  datetimeEmission: null,
  indentificator: null,
  issuer: null,
  kind: null,
  series: null,
  title: null,
  valueTotal: null,
  invoiceType: null,
  mainKeyCriticalType: null
};
export default class ProgramGoalPage extends PageComponent {
  static PageInfo = {
    path: "/Program/Detail/:id/Goal/:goal",
    parent: ProgramGoalsPage,
    name: "menu.programgoal",
    permission: { "GOAL_ACCESS": true },
    icon: "award",
    hidden: true
  }

  roles = ["CUSTOMER_USER", "CUSTOMER_ADMIN"];

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = true;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.costumerLoading = false;
    this.state.isModalVisible = null;
    this.state.selectedType = null;
    this.state.selectedBrand = null;
    this.state.modalError = null;
    this.state.changed = false;
    this.state.label = null;
    this.state.goal = null;
    this.state.selectionType = "name";
    this.state.filter = "";
    this.state.doc = null;
    this.state.states = null;
    this.state.region = null;
    this.state.city = null;
    this.state.name = null;
    this.state.users = null;
    this.state.selectedClient = null;
    this.state.form = null;
    this.state.tabmode = "home";
    this.state.hierarchy = null;
    this.state.productGroupDevolutionId = null;
    this.state.fkClientType = null;
    this.state.datetimeRegister = null;
    this.state.promotionalBudgetTypeId = null;
    this.state.percentagegoal = null;
    if (Parsers.parsePermission(["CUSTOMER_USER"]))
      this.roles = [this.roles[1]];
  }

  downloadReport() {
    var f = this.state.data.program.brand.label + "_" + this.data.id + "_" + (typeof this.data.goal !== "undefined" ? this.data.goal : 0) + "_" + (this.state.data.detail.name1 + (this.state.data.detail.name2 == null ? "" : this.state.data.detail.name2)
      + (this.state.data.detail.name3 == null ? "" : this.state.data.detail.name3)
      + (this.state.data.detail.name4 == null ? "" : this.state.data.detail.name4)) + ".xlsx";
    this.setState({ isModalVisible: "downloading", modalInitializing: true });
    Connection.Secure(Connection.service + 'Report/Statament/Program/' + this.data.id + "/Client/" + (typeof this.data.goal !== "undefined" ? this.data.goal : 0) + "/" + f)
      .then(res => res.blob())
      .then(blob => {
        this.setState({ isModalVisible: null });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = f;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
      });
  }

  componentDidMount() {
    Connection.Secure(Connection.service + 'Report/Goal/Program/' + this.data.id + "/Client/" + (typeof this.data.goal !== "undefined" ? this.data.goal : 0))
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((dataa) => {
            this.state.percentagegoal = dataa;
            setTimeout(() => this.setState({ dataa: this.state.percentagegoal }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });

    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + (typeof this.data.goal !== "undefined" ? this.data.goal : 0))
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false, status: data.purchasingGoal.purchasingGoalStatusElement[0] }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  checkExpired() {
    try {
      return (new Date(this.state.data.program.dateLimitAcceptance)) < Date.now;
    } catch (e) {
      return true;
    }
  }

  addNewFile() {
    this.setState({ modalLoading: true });

    var data = new FormData();

    data.append('data', JSON.stringify(this.state.form));
    data.append('target', this.state.selectedType);
    data.append('file', this.state.file.files[0]);
    data.append('observation', this.state.observation);

    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Award/Action/File",
      {
        "method": "POST",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => {
            for (let i = 0; i < this.state.data.qualitativeAward.qaActionPlan.length; i++) {
              if (this.state.data.qualitativeAward.qaActionPlan[i].id == this.state.selectedType)
                this.state.data.qualitativeAward.qaActionPlan[i].qaActionPlanInvoice.push(t);
            }
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  deleteItem(item) {
    return new Promise((resolve, reject) => {
      this.setState({ modalLoading: true });
      Connection.Secure(Connection.service + (
        "Company/RemoveUser/" + item.mainCompany.keyRegister + "/User/" + item.mainPerson.keyRegister + "/PermissionGroup/" + encodeURI(item.logicalApGroups.name)
      ),
        {
          "method": "DELETE",
          "headers": {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          if (response.ok && response.status == 200) {
            try {
              this.state.data.company.personPermissionGroup.splice(this.state.data.company.personPermissionGroup.indexOf(item), 1);
            } catch (e) { }
            this.setState({ modalLoading: false, isModalVisible: false, data: this.state.data });
            resolve();
          } else {
            this.setState({ modalError: response, modalLoading: false });
            reject(response);
          }
        })
        .catch((error) => {
          this.setState({ modalError: error, modalLoading: false });
          reject(error);
        });
    });
  }

  async saveUser() {
    if (this.checkFocalPoint(this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_APPROVE_GDM ? "CUSTOMER_USER" : "CUSTOMER_ADMIN")) {
      var v = Array.isArray(this.state.users) && this.state.users.length > 0 ? this.state.users : [], r = [];

      for (let i = 0; i < v.length; i++) {
        if (v[i].logicalApGroups.name == (this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_APPROVE_GDM ? "CUSTOMER_USER" : "CUSTOMER_ADMIN")) {
          r.push(v[i]);
        }
      }

      try {
        // Aguarde a exclusão de todos os itens antes de continuar
        await Promise.all(r.map((item) => this.deleteItem(item)));
      } catch (error) {
        console.error("Erro ao excluir itens:", error);
        this.setState({ modalError: error, modalLoading: false });
        return;
      }
    }

    this.state.form.personPermissionGroupMainPerson = [{ logicalApGroups: { name: this.state.selectedRole } }];
    this.state.form.personValue = [
      { value: this.state.form.userName, valueType: { keyConstant: 1 } },
      { value: this.state.form.email, valueType: { keyConstant: 3 } }
    ];

    try {
      const response = await Connection.Secure(
        Connection.service + 'Company/AddUser/' + this.data.goal + (this.state.selectedUser == null ? "" : "/Override/" + this.state.selectedUser.mainPerson.keyRegister),
        {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.state.form)
        }
      );

      if (response.ok && response.status == 200) {
        const data = await response.json();
        var l = (window.location.pathname.replace(/\/$/ig, "") + "/User/" + data).replace(/\/\//ig, "/");
        this.setState({ isModalVisible: "changestatus", statusAction: true, modalLoading: false, modalError: null });
      } else if (response.status == 409) {
        this.setState({ isModalVisible: "alreadyuser", modalLoading: false });
      } else if (response.status == 208) {
        this.setState({ isModalVisible: "sameuser", modalLoading: false });
      } else {
        this.setState({ modalError: response, modalLoading: false });
      }
    } catch (error) {
      this.setState({ modalError: error, modalLoading: false });
    }
  }


  saveGoal(t) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      'Program/' + this.data.id + "/Client/" + this.data.goal,
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ goal: parseInt(t) })
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(st => {
            this.state.status = st;
            this.state.data.purchasingGoal.goal = t;
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  addActionPlan(t) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      'Program/' + this.data.id + "/Client/" + this.data.goal + "/Award/Action",
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(t)
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(t => {
            this.state.data.qualitativeAward.qaActionPlan.push(t);
            this.setState({ modalLoading: false, isModalVisible: null, qualitativeAward: this.state.data.qualitativeAward });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  includeInProgram() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      'Program/' + this.data.id + "/Client/" + this.data.goal + "/Award",
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          maximumInvestment:
            this.state.data.program.qualitativeAwardType.keyConstant == 1 ?
              this.state.data.purchasingGoal.goal * this.state.data.program.qualitativeAwardMultiplier :
              this.state.data.program.qualitativeAwardMultiplier * this.state.selectedUser
        })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => this.setState({ modalLoading: false, isModalVisible: null, qualitativeAward: t }));
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  RemoveAwardProgram() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      'Program/' + this.data.id + "/Client/" + this.data.goal + "/Award",
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          this.setState({ modalLoading: false, isModalVisible: null, qualitativeAward: null });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }


  changeStatus() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      'Program/' + this.data.id + "/Client/" + this.data.goal + "/Status",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ programStatus: { keyConstant: this.getNext(this.state.statusAction).status }, observation: typeof this.state.form.observation === "string" ? this.state.form.observation : null })
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(t => {
            this.state.status = t;
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  getNext(positive) {
    var r = [0, "", null];
    switch (this.state.status.programStatus.keyConstant) {
      case Parsers.GOAL_STATUS.GOAL_CREATED:
      case Parsers.GOAL_STATUS.GOAL_EDITED:
        r = [Parsers.GOAL_STATUS.GOAL_PUBLISHED, Parsers.GOAL_PERMISSIONS.GOAL_PUBLISH, "changestatus"];
        break;
      case Parsers.GOAL_STATUS.GOAL_PUBLISHED:
        r = positive == false ? [Parsers.GOAL_STATUS.GOAL_DECLINED_GF, Parsers.GOAL_PERMISSIONS.GOAL_APPROVAL_GF, "changestatus"] : [Parsers.GOAL_STATUS.GOAL_APPROVE_GF, Parsers.GOAL_PERMISSIONS.GOAL_APPROVAL_GF, "changestatus", true];
        break;
      case Parsers.GOAL_STATUS.GOAL_APPROVE_GF:
        r = positive == false ? [Parsers.GOAL_STATUS.GOAL_DECLINED_GDM, Parsers.GOAL_PERMISSIONS.GOAL_APPROVAL_GDM, "changestatus"] : [Parsers.GOAL_STATUS.GOAL_APPROVE_GDM, Parsers.GOAL_PERMISSIONS.GOAL_APPROVAL_GDM, "changestatus", true];
        break;
      case Parsers.GOAL_STATUS.GOAL_APPROVE_GDM:
        r = [Parsers.GOAL_STATUS.GOAL_APPROVE_CUSTOMER_USER, Parsers.GOAL_PERMISSIONS.GOAL_APPROVE_CUSTOMER_USER, "checkusers"];
        break;
      case Parsers.GOAL_STATUS.GOAL_APPROVE_CUSTOMER_USER:
        r = [Parsers.GOAL_STATUS.GOAL_APPROVE_CUSTOMER_ADMIN, Parsers.GOAL_PERMISSIONS.GOAL_APPROVE_CUSTOMER_ADMIN, "checkusers"];
        break;
      case Parsers.GOAL_STATUS.GOAL_APPROVE_CUSTOMER_ADMIN:
        r = [Parsers.GOAL_STATUS.GOAL_ACCEPT, Parsers.GOAL_PERMISSIONS.GOAL_ACCEPT, "changestatus", false, ["CUSTOMER_ADMIN", "CUSTOMER_USER"]];
        break;
    }
    return { status: r[0], permission: r[1], action: r[2], decline: r.length < 4 ? false : r[3], users: r.length < 5 ? null : r[4] };
  }

  deleteGoal() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          this.props.history.replace("/Program/Detail/" + this.data.id + "/goals");
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  updateValues() {
    for (var i in this.state.form)
      this.state.data[i] = this.parseDate(this.state.form[i]);
    this.setState({ data: this.state.data, isModalVisible: null, changed: true });
  }


  parseDate(t) {
    t = t.split('/');
    return t[2] + "-" + t[1] + "-" + t[0] + "T00:00:00";
  }

  changeDropdown(target) {
    this.setState({ selectionType: target, filter: "" });
  }

  openModal(target, props) {
    var v = {};
    props = typeof props === "object" && props != null ? props : {};
    props.isModalVisible = target;
    props.modalInitializing = false;
    props.modalLoading = false;
    props.selectedUser = null;
    props.users = null;
    props.form = {}
    props.modalError = null;
    if (target == "actionplan") {
      props.form = { label: null, amount: null, valueUnitary: null, dateEvent: null }
    } else if (target == "file")
      props.form = JSON.parse(JSON.stringify(defaultInvoice));
    else if (target == "award") {
      Connection.Secure(Connection.service + 'SalesReport/History/Customer/' + this.data.goal + '/Program/' + this.data.id)
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.setState({ selectedUser: data }, this.setState({ modalInitializing: false }));
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    }
    else if (target == "checkusers") {
      Connection.Secure(Connection.service + 'Company/User/' + this.data.goal)
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.setState({ users: data, modalInitializing: false });
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    } else if (target == "stategroup") {
      Connection.Secure(Connection.service + "StateGroup/List/" + this.state.data.program.brand.keyConstant)
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then(data =>
              this.setState({ modalInitializing: false, statesgroups: data })
            );
          else this.setState({ modalError: response, modalInitializing: false });
        }
        )
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    }
    this.setState(props);
  }


  updateStateGroup() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Franchisee",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ mainCompany: { keyRegister: this.state.selectedFranchisee.detail.customerCode }, stateGroup: this.state.selectedStateGroup })
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(t => {
            this.state.data.franchisee = t;
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  onTabChange(t) {
    this.setState({ tabmode: t }, () => {

      if (t == "clients")
        this.loadClients();
    });
  }

  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  checkForm(target) {
    for (var i in target)
      if (target[i] == null) return false;
    return true;
  }

  calcTotal(target) {
    var v = 0;
    for (let i = 0; i < target.qaActionPlanInvoice.length; i++) {
      v += target.qaActionPlanInvoice[i].invoice.valueTotal;
    }
    return v;
  }

  loadFranchisee(target) {
    this.setState({ selectedStateGroup: { keyConstant: target }, selectedFranchisee: null, loadingFranchisee: null });
    Connection.Secure(Connection.service + "Franchisee/" + target,
      {
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ loadingFranchisee: data });
          });
        else this.setState({ loadingFranchisee: null });
      })
      .catch((error) => {
        this.setState({ loadingFranchisee: null });
      });
  }

  selectFranchisee(data, target) {
    if (Array.isArray(data))
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.detail.customerCode == target) return element;

      }
    return null;
  }

  renderUser(item) {
    return <div className="generics_listing_item">
      <FontAwesomeIcon icon="check-circle" className="generics_listing_item_icon" style={{ opacity: 1, color: "rgb(52 164 19)" }} />
      <FontAwesomeIcon icon="user" className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}{item.mainPerson.brand ? <span>{item.mainPerson.brand.label}</span> : null}</div>
        <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.mainPerson.personValue, 9, "valueType", null, "Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 8, "valueType", null, " Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 7, "valueType", null, " ")}</div>
        <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.mainPerson.personValue, 3, "valueType", null, " Email:"))}
          <span>{Labels.GetLabel("permission." + item.logicalApGroups.name)}</span></div>
        <div className="generics_listing_item_description" style={{ textAlign: "right" }}>{Labels.GetLabel("program.lastupdate")}: {Parsers.parseDate(item.mainPerson.datetimeUpdate)}</div>
      </div>
    </div>
  }

  checkFocalPoint(target) {
    if (Array.isArray(this.state.users))
      for (let i = 0; i < this.state.users.length; i++) {
        const element = this.state.users[i];
        if (element.logicalApGroups.name == target) {
          // var d = new Date(element.mainPerson.datetimeUpdate);
          // d.setMonth(d.getMonth() + 6);
          // if (d >= new Date())
          return true;
        }
      }
    return false;
  }

  renderFranchiseeInfo(item, icon, op) {
    // var l = window.location.pathname.replace(/\/$/ig, "") + "/Company/" + item.company.keyRegister;
    return <div className="generics_listing_item" >
      <FontAwesomeIcon icon={icon} className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{item.detail.name1}</div>
        <div className="generics_listing_item_description" >{Parsers.parseCPNJ(item.detail.cnpjCode)}</div>
      </div>
    </div>
  }

  render() {
    return (
      <Container context={this.constructor}>
        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {this.state.data.program.brand.label + " - " + this.state.data.program.label}</span>
                    <div style={{ fontSize: 25 }}>{this.state.data.detail.name1 + (this.state.data.detail.name2 == null ? "" : this.state.data.detail.name2)
                      + (this.state.data.detail.name3 == null ? "" : this.state.data.detail.name3)
                      + (this.state.data.detail.name4 == null ? "" : this.state.data.detail.name4)}</div>
                    <div>{Labels.GetLabel("generic.docnumb")}: {this.state.data.detail == null ? Parsers.parseCPNJ(this.state.data.company.criticalValue) : this.state.data.detail.cnpjCode == null ? Parsers.parseCPNJ(this.state.data.detail.cpfCode) : Parsers.parseCPNJ(this.state.data.detail.cnpjCode)}</div>
                  </div>

                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(this.state.status.programStatus.keyConstant) }}>
                    <div className="generics_status_bar_title">
                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(this.state.status.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />
                      {Labels.GetLabel("STATUS_PROGRAM." + this.state.status.programStatus.keyConstant)}
                    </div>
                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.status.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(this.state.status.datetimeRegister, "time")})</div>
                    <div className="generics_status_bar_desc">
                      {Labels.GetLabel("STATUS_PROGRAM_DESC." + this.state.status.programStatus.keyConstant)}
                    </div>
                    {
                      typeof this.state.status.observation === "string" && this.state.status.observation.length > 0 ?
                        <div className="generics_status_bar_desc">
                          <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel("generic.observation")}:</div>
                          {this.state.status.observation}
                        </div>
                        : null
                    }
                    {(() => {
                      var n = this.getNext();
                      if (!Parsers.parsePermission2(n.permission))
                        return null;
                      if (n.users != null && !Parsers.parsePermission(n.users, this.state.data.company.keyRegister))
                        return null;
                      return <div style={{ textAlign: "right", marginTop: 20 }}>
                        {
                          n.decline == true ?
                            <Button variant="danger" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal(n.action, { statusAction: false })}>
                              {Labels.GetLabel("STATUS_PROGRAM_ACTION." + this.getNext(false).status)}
                            </Button>
                            : null
                        }
                        <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal(n.action, { statusAction: true })}>
                          {Labels.GetLabel("STATUS_PROGRAM_ACTION." + this.state.status.programStatus.keyConstant)}
                        </Button>
                      </div>;
                    }
                    )()}
                  </div>
                  <div style={{ padding: 20 }}>

                    <div>
                      <div style={{ fontSize: 14 }}>{Labels.GetLabel("menu.programgoal")}</div>
                      <div style={{ fontSize: 25, fontWeight: "bold" }}>{Parsers.parseNumber(this.state.data.purchasingGoal.goal, true)}{Labels.GetLabel("UNIT_TYPE_UNIT.1")}</div>
                      <div className="goal_bar">
                        <div className="goal_bar_indicator" style={{ width: (this.state.percentagegoal != null ? this.state.percentagegoal.goalHit.toFixed(2) : 0) + "%" }}></div>
                      </div>
                      <div>{Labels.GetLabel("program.goalwarning")}</div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 14 }}>{Labels.GetLabel("menu.totalgoal")}</div>
                        <div style={{ fontSize: 25, fontWeight: "bold" }}> {(this.state.percentagegoal != null ? Parsers.parseNumber(this.state.percentagegoal.goal, true) : 0)}{Labels.GetLabel("UNIT_TYPE_UNIT.1")} ({(this.state.percentagegoal != null ? this.state.percentagegoal.goalHit.toFixed(2).replace('.', ',') : 0)}%)</div>
                      </div>
                    </div>
                    <br />
                    {
                      this.state.data.qualitativeAward != null && (!Parsers.parsePermission(["CUSTOMER_ADMIN", "CUSTOMER_USER"], this.state.data.company.keyRegister) || this.state.data.qualitativeAward.qaActionPlan.length > 0) ?
                        <div>
                          <div className="generic_section_header">{Labels.GetLabel("program.qualitativeaward")}
                          </div>
                          <Link to={"/Program/Detail/" + this.data.id + "/Goal/" + this.data.goal + "/QualitativeAward"}>
                            {
                              !Parsers.parsePermission2(["QAWARD_ACCESS"]) ? null :
                                <div style={{ marginBottom: 20 }}>
                                  <div>{Labels.GetLabel("program_refund.investmentused")} / {Labels.GetLabel("program_refund.investmenttotal")}</div>
                                  <div style={{ fontWeight: "bold", fontSize: 25 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.totalInvestment)} / {Parsers.parseMoney(this.state.data.qualitativeAward.maximumInvestment)}</div>
                                </div>
                            }
                          </Link>
                        </div>
                        : null
                    }

                    {
                      Parsers.parsePermission(["CUSTOMER_ADMIN", "CUSTOMER_USER"], this.state.data.company.keyRegister) ? null :
                        <div>
                          <div className="generic_section_header">{Labels.GetLabel('program.clientinfo')}</div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.customercode")}</div>
                            <div className="generics_infobox_value">{this.state.data.detail.customerCode}</div>
                          </div>
                          {
                            this.state.data.detail.headOfficeAcc == null ? null :
                              <div className="generics_infobox">
                                <div className="generics_infobox_label">{Labels.GetLabel("generic.payercode")}</div>
                                <div className="generics_infobox_value">{this.state.data.detail.headOfficeAcc}</div>
                              </div>}
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("program.type")}</div>
                            <div className="generics_infobox_value">{Labels.GetLabel("CLIENT_TYPE." + this.state.data.detail.customerType.bunch)}</div>
                          </div>
                          <div style={{ clear: "both" }}></div>
                          <br />
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.street")}</div>
                            <div className="generics_infobox_value">{this.state.data.detail.street}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.streetnumb")}</div>
                            <div className="generics_infobox_value">{parseInt(this.state.data.detail.addressNr)}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.streetcode")}</div>
                            <div className="generics_infobox_value">{this.state.data.detail.postalCode}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.state")}</div>
                            <div className="generics_infobox_value">{this.state.data.detail.region}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.city")}</div>
                            <div className="generics_infobox_value">{this.state.data.detail.city}</div>
                          </div>
                          <div className="generics_infobox">
                            <div className="generics_infobox_label">{Labels.GetLabel("generic.accountgroup")}</div>
                            <div className="generics_infobox_value">{this.state.data.detail.accountGroup}</div>
                          </div>
                          <div style={{ clear: "both" }}></div>
                          {this.state.data.franchisee != null ?
                            <div>
                              <div className="generic_section_header">{Labels.GetLabel('adminstategroupdetail.EMPLOYEE_FRANCHISEE_listing2')}</div>
                              <div className="generics_infobox">
                                <div className="generics_infobox_label">{Labels.GetLabel("menu.stategroup")}</div>
                                <div className="generics_infobox_value">{this.state.data.purchasingGoal.stateGroup.label}</div>
                              </div>
                              <div className="generics_infobox">
                                <div className="generics_infobox_label">{Labels.GetLabel("generic.name")}</div>
                                <div className="generics_infobox_value">{this.state.data.franchisee.name}</div>
                              </div>
                              <div style={{ clear: "both" }}></div>
                              {this.state.data.franchisee.personPermissionGroup.length == 0 ?
                                <div className="generics_infobox">
                                  <div className="generics_infobox_label">{Labels.GetLabel("permission.FRANCHISEE_ADMIN")}</div>
                                  <div className="generics_infobox_value">N/A</div></div> :
                                this.state.data.franchisee.personPermissionGroup.map(item =>
                                  <div className="generics_infobox">
                                    <div className="generics_infobox_label">{Labels.GetLabel("permission." + item.logicalApGroups.name)}</div>
                                    <div className="generics_infobox_value">{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}</div>
                                  </div>)}
                              <div style={{ clear: "both" }}></div>
                            </div>
                            : null
                          }
                        </div>
                    }
                    <br />
                    <div>

                      <div className="generic_section_header">{Labels.GetLabel('generic.files')}</div>
                      <div>
                        {this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_ACCEPT ?
                          <div style={{ textAlign: "right", marginTop: 20 }}>
                            <a href={Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/download/" + encodeURIComponent(this.data.id + "_" + this.data.goal + "_" + Labels.GetLabel("program.agreementletterfile")) + ".pdf"} className="generics_listing_item" target="_blank" >
                              <FontAwesomeIcon icon="file" className="generics_listing_item_icon" />
                              <div className="generics_listing_content" >
                                <div className="generics_listing_item_title" style={{ textAlign: "left" }} >{Labels.GetLabel("program.downloadagreementletter")}</div>
                                <div style={{ textAlign: "right" }}>{this.data.id + "_" + this.data.goal + "_" + Labels.GetLabel("program.agreementletterfile") + ".pdf"}</div>
                              </div>
                            </a>
                          </div>
                          : null}
                        {this.state.data.program.storageProgramElement == null || this.state.data.program.storageProgramElement.length == 0 ?
                          <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div> :
                          this.state.data.program.storageProgramElement.map(item => <a href={Connection.service + "Program/" + this.data.id + "/File/" + item.storageManager.keyConstant + "/" + item.storageManager.filename} className="generics_listing_item" target="_blank" >
                            <FontAwesomeIcon icon="file" className="generics_listing_item_icon" />
                            <div className="generics_listing_content" >
                              <div className="generics_listing_item_title" >{item.storageManager.value}</div>
                              <div className="generics_listing_item_description" >{item.observation}</div>
                              <div style={{ textAlign: "right" }}>{item.storageManager.filename}</div>
                            </div>
                          </a>)}
                      </div>
                      <br />
                    </div>

                    <br />
                    <br />
                  </div>
                </div>
                <div className="generics_actionbar">

                  {/* <DropdownButton disabled={this.state.changed}
                  as={ButtonGroup}
                  key="up"
                  drop="up"
                  variant="primary"
                  title={Labels.GetLabel("program.alterstatus")}
                  onSelect={(t) => this.openModal(t)}
                >
                  <Dropdown.Item eventKey="3">{Labels.GetLabel("STATUS_PROGRAM_DO.3")}</Dropdown.Item>
                  <Dropdown.Item eventKey="4">{Labels.GetLabel("STATUS_PROGRAM_DO.4")}</Dropdown.Item>
                  <Dropdown.Item eventKey="5">{Labels.GetLabel("STATUS_PROGRAM_DO.5")}</Dropdown.Item>
                  <Dropdown.Item eventKey="10">{Labels.GetLabel("STATUS_PROGRAM_DO.10")}</Dropdown.Item>
                  <Dropdown.Item eventKey="9">{Labels.GetLabel("STATUS_PROGRAM_DO.9")}</Dropdown.Item>
                </DropdownButton> */}
                  {!Parsers.parsePermission2(["GOAL_EDIT"]) ? null :
                    <DropdownButton disabled={this.state.changed}
                      as={ButtonGroup}
                      key="up"
                      drop="up"
                      variant="primary" style={{ marginRight: 10 }}
                      title={Labels.GetLabel("program.edit")}
                      onSelect={(t) => this.openModal(t)}
                    >
                      <Dropdown.Item eventKey="goal" disabled={this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_ACCEPT}>{Labels.GetLabel("program.programgoal")}</Dropdown.Item>
                      <Dropdown.Item eventKey="award"
                        disabled={this.state.data.qualitativeAward != null && Array.isArray(this.state.data.qualitativeAward.qaActionPlan) && this.state.data.qualitativeAward.qaActionPlan.length > 0}
                      >{Labels.GetLabel("program.qualitativeaward")}</Dropdown.Item>
                      <Dropdown.Item eventKey="stategroup">{Labels.GetLabel("adminstategroupdetail.EMPLOYEE_FRANCHISEE_listing2")}</Dropdown.Item>
                      {/* <Dropdown.Item eventKey="actionplan" disabled={this.state.data.qualitativeAward == null || this.state.status.programStatus.keyConstant != 10}
                      >{Labels.GetLabel("program.actionplan")}</Dropdown.Item> */}
                      {
                        this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_CREATED ||
                          this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_EDITED ||
                          this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_DECLINED_GDM ||
                          this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_DECLINED_GF ?
                          <Dropdown.Item eventKey="deletegoal">{Labels.GetLabel("program.deletegoal")}</Dropdown.Item>
                          : null
                      }
                    </DropdownButton>
                  }
                  {/* {Parsers.parsePermission2(["GOAL_EDIT"]) || !Parsers.parsePermission2(["ACTION_PLAN_CREATION"]) || this.state.data.qualitativeAward == null ? null :
                    <DropdownButton disabled={this.state.changed}
                      as={ButtonGroup}
                      key="up"
                      drop="up"
                      variant="primary" style={{ marginRight: 10 }}
                      title={Labels.GetLabel("program.edit")}
                      onSelect={(t) => this.openModal(t)}
                    >
                      <Dropdown.Item disabled={this.state.status.programStatus.keyConstant != 10}
                        eventKey="actionplan">{Labels.GetLabel("program.actionplan")}</Dropdown.Item>
                    </DropdownButton>
                  } */}
                  <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.openModal("history")}>
                    {Labels.GetLabel("generic.history")}
                  </Button>
                  <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.downloadReport()}>
                    {Labels.GetLabel("program.statement")}
                  </Button>
                  <Button variant="primary" style={{}} onClick={() => this.props.history.push('/Program/Detail/' + this.data.id + '/Goal/' + this.data.goal + '/CustomerResult')}>
                    {/* this.props.history.push('/Program/Detail/' + this.data.id + '/Goals') */}
                    {Labels.GetLabel("program.customerresult")}
                  </Button>
                  <div style={{ flex: 1 }}></div>
                  <div style={{ clear: "both" }}></div>
                </div>
                <Modal
                  className={this.state.modalLoading == true ? "modal-loading" : ""}
                  onHide={() => { }} show={this.state.isModalVisible != null} >
                  <div>
                    {
                      this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                        <div>
                          {Labels.GetLabel("adminstategroup.saving")}
                        </div>
                        :
                        this.state.isModalVisible == "goal" ?
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("program.programgoal")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <MaskedInput type="int" notnull={true} label={Labels.GetLabel("generic.value") + " (" + Labels.GetLabel("UNIT_TYPE_UNIT.1") + " )"} value={"" + this.state.data.purchasingGoal.goal} onValid={(value) => this.setState({ goal: value })}
                                onInvalid={(value) => this.setState({ goal: null })} />
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("adminstategroup.closebtn")}
                              </Button>
                              <Button variant="primary" disable={this.state.goal == null} onClick={() => this.saveGoal(this.state.goal)}>
                                {Labels.GetLabel("adminstategroup.savebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div> : this.state.isModalVisible == "stategroup" ?
                            <div>
                              <Modal.Header>
                                <Modal.Title>{Labels.GetLabel("adminstategroupdetail.EMPLOYEE_FRANCHISEE_listing2")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div>
                                  <br />
                                  <MaskedInput type="select" label={Labels.GetLabel("adminstategroup.newlabel")} notnull={true}
                                    onValid={(value) => this.loadFranchisee(parseInt(value[0]))}
                                    onInvalid={(value) => this.setState({ selectedStateGroup: null, selectedFranchisee: null })}
                                    name="keyConstant,label" data={this.state.statesgroups} placeholder={Labels.GetLabel("generic.select")} />
                                  {
                                    this.state.selectedStateGroup == null ? null :
                                      <div>
                                        {this.state.loadingFranchisee == null ?
                                          <div><FontAwesomeIcon spin={true} icon="cog" /> {Labels.GetLabel("generic.loading")}</div>
                                          :
                                          <div>
                                            <MaskedInput type="select" label={Labels.GetLabel("adminstategroupdetail.EMPLOYEE_FRANCHISEE")} notnull={true}
                                              onValid={(value, target) => { var v = this.selectFranchisee(target.getData(), value[0]); this.setState({ selectedFranchisee: v }) }}
                                              onInvalid={(value) => this.setState({ selectedFranchisee: null })}
                                              name={(d) => [d.detail.customerCode, d.detail.name1 + (d.detail.name2 == null ? "" : d.detail.name2)
                                                + (d.detail.name3 == null ? "" : d.detail.name3)
                                                + (d.detail.name4 == null ? "" : d.detail.name4)]
                                              } parser={(t, v, d) => {
                                                return d.detail.name1 + (d.detail.name2 == null ? "" : d.detail.name2)
                                                  + (d.detail.name3 == null ? "" : d.detail.name3)
                                                  + (d.detail.name4 == null ? "" : d.detail.name4)
                                              }
                                              } data={this.state.loadingFranchisee} placeholder={Labels.GetLabel("generic.select")} />

                                            {this.state.selectedFranchisee != null ?
                                              <div>
                                                {this.state.selectedFranchisee.mainCompany.personPermissionGroup.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div> :
                                                  this.state.selectedFranchisee.mainCompany.personPermissionGroup.map(item => <div className="generics_listing_item" >
                                                    <FontAwesomeIcon icon="user" className="generics_listing_item_icon" />
                                                    <div className="generics_listing_content" >
                                                      <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}{item.mainPerson.brand ? <span>{item.mainPerson.brand.label}</span> : null}</div>
                                                      <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.mainPerson.personValue, 9, "valueType", null, "Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 8, "valueType", null, " Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 7, "valueType", null, " ")}</div>
                                                      <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.mainPerson.personValue, 3, "valueType", null, " Email:"))}
                                                        <span>{Labels.GetLabel("permission." + item.logicalApGroups.name)}</span></div>
                                                    </div>
                                                  </div>)}
                                              </div> : null}
                                          </div>}
                                      </div>
                                  }
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                </Button>
                                <Button variant="primary" disabled={this.state.selectedFranchisee == null} onClick={() => this.updateStateGroup()}>
                                  {Labels.GetLabel("adminstategroup.savebtn")}
                                </Button>
                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                            </div>
                            :
                            this.state.isModalVisible == "deletegoal" ?
                              <div>
                                <Modal.Header>
                                  <Modal.Title>{Labels.GetLabel("program.deletegoal")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  {Labels.GetLabel("generic.confirmdel")}
                                  <br />
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                    {Labels.GetLabel("adminstategroup.closebtn")}
                                  </Button>
                                  <Button variant="primary" onClick={() => this.deleteGoal()}>
                                    {Labels.GetLabel("generic.confirm")}
                                  </Button>
                                </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                              </div>
                              :
                              this.state.isModalVisible == "actionplan" ? (
                                this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_ACCEPT ?

                                  <div>
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("program.actionplan")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program_refund.investmenttotal")}</div>
                                      <div style={{ fontSize: 20 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.maximumInvestment)}</div>
                                      <br />
                                      <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program_refund.investmentused")}</div>
                                      <div style={{ fontSize: 20 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.totalInvestment)}</div>
                                      <br />
                                      <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program_refund.investmentavailable")}</div>
                                      <div style={{ fontSize: 20 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.maximumInvestment - this.state.data.qualitativeAward.totalInvestment)}</div>
                                      <br />
                                      <MaskedInput type="text" notnull={true} label={Labels.GetLabel("program.action")} onValid={(value) => this.updateForm("label", value)}
                                        onInvalid={(value) => this.updateForm("label", null)} />
                                      <MaskedInput type="int" notnull={true} label={Labels.GetLabel("program.quantity")} onValid={(value) => this.updateForm("amount", Parsers.normalizeNumber(value))}
                                        onInvalid={(value) => this.updateForm("amount", null)} />
                                      <MaskedInput type="decimal" notnull={true} label={Labels.GetLabel("program.uvalue")} onValid={(value) => this.updateForm("valueUnitary", Parsers.normalizeNumber(value))}
                                        onInvalid={(value) => this.updateForm("valueUnitary", null)} />
                                      <MaskedInput type="date" notnull={true} label={Labels.GetLabel("program.evdate")} onValid={(value) => this.updateForm("dateEvent", this.parseDate(value))}
                                        onInvalid={(value) => this.updateForm("dateEvent", null)} />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                      </Button>
                                      <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.addActionPlan(this.state.form)}>
                                        {Labels.GetLabel("adminstategroup.savebtn")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div> :

                                  <div>
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("program.actionplan")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {Labels.GetLabel("program.waitingaccept")}
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="primary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("generic.confirm")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div>
                              )
                                :
                                this.state.isModalVisible == "award" ?
                                  <div>
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("program.qualitativeaward")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {this.state.data.qualitativeAward != null ? Labels.GetLabel("programgoal.removeaward") : Labels.GetLabel("programgoal.newaward")}
                                      {this.state.data.qualitativeAward != null ? null :
                                        <div>
                                          <br />
                                          <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("qualitative_award_type." + this.state.data.program.qualitativeAwardType.keyConstant)}
                                          </div>
                                          {this.state.data.program.qualitativeAwardType.keyConstant == 1 ?
                                            <div>
                                              {this.state.data.purchasingGoal.goal} x {Parsers.parseMoney(this.state.data.program.qualitativeAwardMultiplier)}= {Parsers.parseMoney((this.state.data.program.qualitativeAwardMultiplier) * this.state.data.purchasingGoal.goal)}
                                            </div> :
                                            <div>
                                              {Parsers.parseMoney(this.state.selectedUser)} x {Parsers.parseMoney(this.state.data.program.qualitativeAwardMultiplier)} = {Parsers.parseMoney((this.state.data.program.qualitativeAwardMultiplier) * this.state.selectedUser)}
                                            </div>}
                                        </div>
                                      }
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                      </Button>
                                      <Button variant="primary"
                                        disabled={this.state.data.program.qualitativeAwardType.keyConstant == 2 && this.state.selectedUser == 0}
                                        onClick={() => this.state.data.qualitativeAward != null ? this.RemoveAwardProgram() : this.includeInProgram()}>
                                        {Labels.GetLabel("generic.confirm")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div>
                                  : this.state.isModalVisible == "file" ?
                                    <div>
                                      <Modal.Header>
                                        <Modal.Title>{Labels.GetLabel("program.refund")}</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <MaskedInput type="select" data={this.state.data.qualitativeAward.qaActionPlan} notnull={true} onValid={(value) => this.setState({ selectedType: value[0] })} label={Labels.GetLabel("program_refund.ActionPlan")}
                                          onInvalid={(value) => this.setState({ selectedType: null })} placeholder={Labels.GetLabel("generic.select")} name="id,label" />
                                        <MaskedInput type="select" data={["NOTA_FISCAL", "CUPOM_FISCAL", "RECIBO_PAPEL"]} notnull={true} onValid={(value) => this.updateForm("invoiceType", { KeyRegister: value[0] })} label={Labels.GetLabel("program_refund.InvoiceType")}
                                          onInvalid={(value) => this.updateForm("invoiceType", null)} placeholder={Labels.GetLabel("generic.select")} />
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("title", value)} label={Labels.GetLabel("program_refund.Title")}
                                          onInvalid={(value) => this.updateForm("title", null)} />
                                        <MaskedInput type="select" name="keyConstant,label" data={[{ keyConstant: 2, label: "DOC_CNPJ" }, { keyConstant: 1, label: "DOC_CPF" }]} notnull={true} onValid={(value) => this.updateForm("mainKeyCriticalType", { keyConstant: parseInt(value[0]) })} label={Labels.GetLabel("program_refund.MainKeyCriticalType")}
                                          onInvalid={(value) => this.updateForm("mainKeyCriticalType", null)} placeholder={Labels.GetLabel("generic.select")} parser={(t) => Labels.GetLabel("information." + t)} />
                                        {
                                          this.state.form.mainKeyCriticalType == null ? null :
                                            this.state.form.mainKeyCriticalType.KeyRegister == "DOC_CNPJ" ?
                                              <MaskedInput type="cnpj" notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("program_refund.criticalValue")}
                                                onInvalid={(value) => this.updateForm("criticalValue", null)} /> :
                                              <MaskedInput type="cpf" notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("program_refund.criticalValue")}
                                                onInvalid={(value) => this.updateForm("criticalValue", null)} />
                                        }
                                        <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("datetimeEmission", this.parseDate(value))} label={Labels.GetLabel("program_refund.DatetimeEmission")}
                                          onInvalid={(value) => this.updateForm("datetimeEmission", null)} />
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("indentificator", value)} label={Labels.GetLabel("program_refund.Indentificator")}
                                          onInvalid={(value) => this.updateForm("indentificator", null)} />
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("issuer", value)} label={Labels.GetLabel("program_refund.Issuer")}
                                          onInvalid={(value) => this.updateForm("issuer", null)} />
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("kind", value)} label={Labels.GetLabel("program_refund.Kind")}
                                          onInvalid={(value) => this.updateForm("kind", null)} />
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("series", value)} label={Labels.GetLabel("program_refund.Series")}
                                          onInvalid={(value) => this.updateForm("series", null)} />
                                        <MaskedInput type="decimal" notnull={true} onValid={(value) => this.updateForm("valueTotal", parseFloat(value.replace(".", "").replace(",", ".")))} label={Labels.GetLabel("program_refund.ValueTotal")}
                                          onInvalid={(value) => this.updateForm("valueTotal", null)} />
                                        <Form.Label>{Labels.GetLabel("program_refund.file")}</Form.Label>
                                        <Form.File id="exampleFormControlFile1" onChange={t => this.setState({ file: t.target })} />
                                        <br />
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.setState({ observation: value })} label={Labels.GetLabel("program_refund.Obs")}
                                          onInvalid={(value) => this.setState({ observation: null })} />
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                          {Labels.GetLabel("adminstategroup.closebtn")}
                                        </Button>
                                        <Button variant="primary" disabled={this.state.selectedType == null || this.state.observation == null || this.state.file == null || !this.checkForm(this.state.form)} onClick={() => this.addNewFile()}>
                                          {Labels.GetLabel("adminstategroup.savebtn")}
                                        </Button>
                                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                    </div>
                                    : this.state.isModalVisible == "history" ?
                                      <div>
                                        <Modal.Header>
                                          <Modal.Title>{Labels.GetLabel("generic.history")}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          {
                                            this.state.data.purchasingGoal.purchasingGoalStatusElement.map(t =>
                                              <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(t.programStatus.keyConstant) }}>
                                                <div className="generics_status_bar_title">
                                                  <FontAwesomeIcon icon={Parsers.GetStatusIcon(t.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />{Labels.GetLabel("STATUS_PROGRAM_MODAL." + t.programStatus.keyConstant)}
                                                </div>
                                                <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(t.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(t.datetimeRegister)})</div>
                                              </div>)
                                          }
                                        </Modal.Body>
                                        <Modal.Footer>
                                          <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                            {Labels.GetLabel("adminstategroup.closebtn")}
                                          </Button>
                                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                      </div>
                                      : this.state.isModalVisible == "checkusers" ?
                                        <div>
                                          <Modal.Header>
                                            <Modal.Title>{Labels.GetLabel("program.checkusers")}</Modal.Title>
                                          </Modal.Header>
                                          <Modal.Body>
                                            <div style={{ padding: 10, borderRadius: 10, border: "1px solid rgb(240,240,240)" }}>
                                              {Labels.GetLabel("program.checkuserwarning_" + this.state.status.programStatus.keyConstant)}
                                            </div>
                                            <br />
                                            {(() => {
                                              var v = Array.isArray(this.state.users) && this.state.users.length > 0 ? this.state.users : [], r = [];

                                              for (let i = 0; i < v.length; i++)
                                                if (v[i].logicalApGroups.name == (this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_APPROVE_GDM ? "CUSTOMER_USER" : "CUSTOMER_ADMIN")) r.push(v[i]);

                                              if (r.length == 0) return <div className="generic_empty">{Labels.GetLabel("generic.noresultfound")}</div>
                                              return r.map((item) => this.renderUser(item))
                                            })()}
                                          </Modal.Body>
                                          <Modal.Footer>
                                            <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                              {Labels.GetLabel("adminstategroup.closebtn")}
                                            </Button>
                                            {/* <Button variant="primary" disabled={this.checkFocalPoint(this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_APPROVE_GDM ? "CUSTOMER_USER" : "CUSTOMER_ADMIN")} onClick={() => this.setState({ isModalVisible: "user" })}> */}
                                            <Button variant="primary" onClick={() => this.setState({ isModalVisible: "user" })}>
                                              {Labels.GetLabel("clientdetail.newUser")}
                                            </Button>
                                            <Button variant="primary" disabled={!this.checkFocalPoint(this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_APPROVE_GDM ? "CUSTOMER_USER" : "CUSTOMER_ADMIN")} onClick={() => this.setState({ isModalVisible: "changestatus", statusAction: true })}>
                                              {Labels.GetLabel("generic.confirm")}
                                            </Button>
                                          </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                        </div>
                                        : this.state.isModalVisible == "user" ?
                                          <div>
                                            <Modal.Header>
                                              <Modal.Title>{Labels.GetLabel("clientdetail.newUser")}</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                              <MaskedInput type="select" icon="sitemap" label={Labels.GetLabel("clientdetail.role")} notnull={true} onValid={(value) => this.setState({ selectedRole: value[0] })}
                                                onInvalid={(value) => this.setState({ selectedRole: null })} data={this.state.status.programStatus.keyConstant == Parsers.GOAL_STATUS.GOAL_APPROVE_GDM ? ["CUSTOMER_USER"] : ["CUSTOMER_ADMIN"]} parser={(t) => Labels.GetLabel("permission." + t)} placeholder={Labels.GetLabel("generic.select")} />

                                              <MaskedInput type="fname" value={this.state.selectedUser != null ? Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.selectedUser.mainPerson.personValue, 1, "valueType")) : null} icon="info-circle" label={Labels.GetLabel("clientdetail.username")} notnull={true} onValid={(value) => this.updateForm("userName", (value))}
                                                onInvalid={(value) => this.updateForm("userName", null)} />

                                              <MaskedInput type="cpf" value={this.state.selectedUser != null ? this.state.selectedUser.mainPerson.criticalValue : null} icon="id-card" label={Labels.GetLabel("clientdetail.usercpf")} notnull={true} onValid={(value) => this.updateForm("criticalValue", (value))}
                                                onInvalid={(value) => this.updateForm("criticalValue", null)} />

                                              <MaskedInput type="email" value={this.state.selectedUser != null ? Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.selectedUser.mainPerson.personValue, 3, "valueType")) : null} icon="envelope" label={Labels.GetLabel("clientdetail.email")} notnull={true} onValid={(value) => this.updateForm("email", (value))}
                                                onInvalid={(value) => this.updateForm("email", null)} />
                                            </Modal.Body>
                                            <Modal.Footer>
                                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                {Labels.GetLabel("adminstategroup.closebtn")}
                                              </Button>
                                              <Button variant="primary" disabled={this.state.selectedRole == null || !this.checkForm(this.state.form)} onClick={() => this.saveUser()}>
                                                {Labels.GetLabel("adminstategroup.savebtn")}
                                              </Button>
                                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                          </div>
                                          : this.state.isModalVisible == "sameuser" ||
                                            this.state.isModalVisible == "alreadyuser" ?
                                            <div>
                                              <Modal.Header>
                                                <Modal.Title>{Labels.GetLabel("clientdetail.newUser")}</Modal.Title>
                                              </Modal.Header>
                                              <Modal.Body>
                                                {Labels.GetLabel("program." + this.state.isModalVisible)}
                                              </Modal.Body>
                                              <Modal.Footer>
                                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                                </Button>
                                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                            </div> :
                                            (() => {
                                              var n = this.getNext(this.state.statusAction);
                                              return <div>
                                                <Modal.Header>
                                                  <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                                                </Modal.Header>
                                                {this.checkExpired() ?
                                                  <Modal.Body>
                                                    {Labels.GetLabel("program.expiredAccept")}
                                                  </Modal.Body> :
                                                  <Modal.Body>
                                                    {Labels.GetLabel("STATUS_PROGRAM_WARNING." + (n.status))}
                                                    <br />
                                                    <br />
                                                    <br />
                                                    {
                                                      this.state.statusAction == false ?
                                                        <MaskedInput type="text" label={Labels.GetLabel("generic.observation")} notnull={true}
                                                          onValid={(value) => this.updateForm("observation", (value))}
                                                          onInvalid={(value) => this.updateForm("observation", null)} />
                                                        : null
                                                    }
                                                    {!Parsers.parsePermission2(n.permission) || (n.users != null && !Parsers.parsePermission(n.users, this.state.data.company.keyRegister)) ?
                                                      <div style={{ padding: 10, borderRadius: 10, border: "1px solid red", backgroundColor: "#ffe4e4" }}>{Labels.GetLabel("program.owneronly")}</div> :
                                                      n.status == Parsers.GOAL_STATUS.GOAL_ACCEPT ?
                                                        <div>
                                                          <div style={{ padding: 10, borderRadius: 10, border: "1px solid rgb(240,240,240)" }}>
                                                            {this.state.data.program.storageProgramElement == null || this.state.data.program.storageProgramElement.length == 0 ?
                                                              <div className="generic_empty"></div> :
                                                              this.state.data.program.storageProgramElement.map(item => <a href={Connection.service + "Program/" + this.data.id + "/File/" + item.storageManager.keyConstant + "/" + item.storageManager.filename} className="generics_listing_item" target="_blank" >
                                                                <FontAwesomeIcon icon="file" className="generics_listing_item_icon" />
                                                                <div className="generics_listing_content" >
                                                                  <div className="generics_listing_item_title" >{item.storageManager.value}</div>
                                                                  <div className="generics_listing_item_description" >{item.observation}</div>
                                                                  <div style={{ textAlign: "right" }}>{item.storageManager.filename}</div>
                                                                </div>
                                                              </a>)}
                                                          </div>
                                                          <br />
                                                          {(() => {
                                                            if (typeof this.state.form.confirmation === "undefined")
                                                              this.updateForm("confirmation", null);
                                                            return <div onClick={() => this.updateForm("confirmation", this.state.form.confirmation == true ? null : true)}
                                                              style={{ flexDirection: "row", display: "flex", borderRadius: 10, border: "1px solid rgb(240,240,240)", padding: 10, fontSize: 20 }}>
                                                              <div><FontAwesomeIcon style={{ fontSize: 30 }} icon={["far", this.state.form.confirmation == true ? "check-square" : "square"]} /></div>
                                                              <div style={{ flex: 1, marginLeft: 10 }}>{Labels.GetLabel("program.confirmation")}</div>
                                                            </div>
                                                          })()}
                                                        </div>
                                                        : null
                                                    }
                                                  </Modal.Body>
                                                }
                                                <Modal.Footer>
                                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                    {Labels.GetLabel("adminstategroup.closebtn")}
                                                  </Button>
                                                  {!Parsers.parsePermission2(n.permission) ? null :
                                                    <Button variant="primary" disabled={this.checkExpired() || !this.checkForm(this.state.form) ||
                                                      !Parsers.parsePermission2(n.permission) || (n.users != null && !Parsers.parsePermission(n.users, this.state.data.company.keyRegister))} onClick={() => this.changeStatus()}>
                                                      {Labels.GetLabel("generic.confirm")}
                                                    </Button>}
                                                </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                              </div>
                                            })()
                    }
                  </div>
                </Modal>
              </div>
        }
      </Container >
    );
  }
} 